module.exports = __webpack_public_path__ + "static/img/地图@2x.8c7b01b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/地图@2x.png
// module id = 3Mni
// module chunks = 1